import styled from "styled-components";
import { blackColor, orangeColor, whiteColor } from "../../constants/colors";
import { QuestionBlock } from "../Question/styled";

const CostBlock = styled.div`
  background: #e0dff0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding-top: 65px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  .blue {
    position: absolute;
    top: 0;
    left: 0;
  }
  .purple {
    position: absolute;
    top: 300px;
    right: 0;
  }
`;

CostBlock.Wrapper = styled(QuestionBlock.Wrapper)`
  flex-grow: 1;
  z-index: 1;
  padding-bottom: 0;
`;

CostBlock.Top = styled.div`
  @media (max-width: 767px) {
    //margin-top: -35px;
  }
`;
CostBlock.Answers = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin-bottom: 18px;
`;
CostBlock.Answers.Item = styled.div`
  max-width: 75px;
  &.active {
  }
`;
CostBlock.Answers.Item.Top = styled.div`
  width: 75px;
  height: 75px;
  background: #f3f2ff;
  box-sizing: border-box;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 7px;
  transition: 0.1s;
  opacity: 0.7;
  h3 {
    color: ${blackColor};
  }
  &.active {
    border: 2px solid ${orangeColor};
    opacity: 1;
    box-shadow: 0px 4px 16px rgba(240, 119, 51, 0.25);
  }
`;
CostBlock.Answers.Item.Text = styled.div`
  transition: 0.1s;
  &.active {
    p {
      color: ${orangeColor};
    }
  }
`;
CostBlock.Bottom = styled.div`
  background: ${whiteColor};
  padding-top: 29px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 15px 15px 0 0;
  padding-bottom: 36px;
  min-height: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

CostBlock.Bottom.Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  flex-grow: 1;
`;

export { CostBlock };
